import { FC } from "react";

import { useSearchParams } from "next/navigation";

import { FormOverlayButton } from "@/forms-design-system/FormButton/FormOverlayButton";
import { useIsEmbeddedModal, useEmbeddedModal } from "@/hooks/useEmbeddedModal";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { Cross } from "@/icons/outlined";

export const CloseEmbedButton: FC = () => {
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());
  const { isSmallScreen } = useMediaQuery();
  const isEmbeddedModal = useIsEmbeddedModal(query);
  const { postMessageClose } = useEmbeddedModal(isEmbeddedModal);

  if (!isEmbeddedModal || !isSmallScreen) {
    return null;
  }

  return (
    <FormOverlayButton
      iconButton
      startIcon={<Cross />}
      onClick={postMessageClose}
      data-test="ticketing-toggle-locale"
      components={{
        startIcon: {
          size: isSmallScreen ? "medium" : "large",
        },
      }}
      sx={{
        width: { xs: 36, md: 40 },
        height: { xs: 36, md: 40 },
      }}
    />
  );
};
